import { render, staticRenderFns } from "./TextareaField.vue?vue&type=template&id=4aef0517&"
import script from "./TextareaField.vue?vue&type=script&lang=js&"
export * from "./TextareaField.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/themes/default/form.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports